// extracted by mini-css-extract-plugin
module.exports = {"likeButton":"LikeEventButton_likeButton__MfQl7","liked":"LikeEventButton_liked__24Ef6","heartbeat":"LikeEventButton_heartbeat__TEF7S"};